// extracted by mini-css-extract-plugin
module.exports = {"container":"Buttons_container__1xvGc","Validate":"Buttons_Validate__aZ6Zf","Global":"Buttons_Global__2rF_O"};